import { gql } from '@apollo/client';

export const POPULAR_PRODUCTS = gql`
  query Home($pagination: Pagination) {
    listPopularProducts(pagination: $pagination) {
      id
      title
      subtitle
      thumbnail
      author
      books {
        id
        price
      }
    }
  }
`;

export const NEW_BOOKS = gql`
  query Home($sorting: Sorting, $pagination: Pagination) {
    listBooks(sorting: $sorting, pagination: $pagination) {
      id
      title
      subtitle
      author
      comment
      price
      createdAt
      updatedAt
      product {
        id
        title
        subtitle
        thumbnail
        author
      }
    }
  }
`;
